import React from 'react';
import SallyImage from "../../assets/images/userHome/saly.webp";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function CtaImage({ imageSrc = SallyImage }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-full min-h-[160px] bg-background rounded-2xl shadow-md overflow-hidden flex items-center">
      {/* Dekoratif daireler */}
      <div className="absolute w-[220px] h-[220px] bg-[#AF9FB1]/50 rounded-full -top-16 -left-10" />
      <div className="absolute w-[120px] h-[120px] bg-[#cfc5cb]/40 rounded-full -bottom-8 left-8" />

      {/* Metin + buton */}
      <div className="relative z-10 px-5 py-4 max-w-[62%]">
        <h3 className="font-roboto text-[#3b2d4a] text-sm sm:text-base font-semibold leading-snug mb-1.5">
          {t("ctaHeader")}
        </h3>
        <p className="font-roboto text-[#3b2d4a]/70 text-xs mb-3 leading-relaxed">
          {t("ctaTitle")}
        </p>
        <button
          onClick={() => navigate("/userPageDiscover")}
          className="bg-button-bg text-white font-poppins text-xs sm:text-sm px-4 py-1.5 rounded-full shadow hover:bg-green-600 transition duration-300"
        >
          {t("startImmediately")}
        </button>
      </div>

      {/* İllüstrasyon */}
      <div className="absolute right-0 bottom-0 h-full flex items-end pointer-events-none">
        <img
          src={imageSrc}
          alt="Illustration"
          className="h-[140px] sm:h-[160px] object-contain"
        />
      </div>
    </div>
  );
}

export default CtaImage;
